import type { FallbackProps } from 'react-error-boundary';

import { Button } from '@/components/ui/button';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-red-200 bg-red-50 px-6 py-8">
            <p className="text-sm font-medium text-red-800">Something went wrong</p>
            <pre className="max-w-full overflow-auto text-xs text-red-600">
                {error instanceof Error ? error.message : 'Unknown error'}
            </pre>
            <Button variant="outline" size="sm" onClick={resetErrorBoundary}>
                Try again
            </Button>
        </div>
    );
}
